import { createSlice } from "@reduxjs/toolkit";

export const uiStates = createSlice({
  name: "uiStates",
  initialState: {
    walletModal: false,
  },
  reducers: {
    showWalletModal: (state) => {
      state.walletModal = true;
    },
    hideWalletModal: (state) => {
      state.walletModal = false;
    },
  },
});

export const { showWalletModal, hideWalletModal } = uiStates.actions;

export default uiStates.reducer;
